// extracted by mini-css-extract-plugin
module.exports = {"base":"CandorModal_base__2ctTt","afterOpen":"CandorModal_afterOpen__1Y6Pc","beforeClose":"CandorModal_beforeClose__1jOx6"};